// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1g81v"};